import {fetch} from "utils/dataAccess";

export async function wmsShip(shipments) {
    const response = await fetch('/shipments/wmsShip', {
        method: 'POST',
        body: JSON.stringify({
            shipments: shipments
        })
    });

    if (!response.ok) {
        throw new Error('Failed to ship WMS shipments');
    }

    return await response.json();
}
